<template>
  <div class="content">

    <div class=" marg-bottom10">
      <div style="font-size:20px;font-weight: 700;padding-bottom: 10px;">营期</div>
      <van-search
        v-model="serachValue"
        placeholder="请输入营期"
        @input="goSearch()"
      />

      <div style="padding:10px 0">

        <div class="boxs">
          <div
            v-for="(item,index) in searchList"
            :key="index"
            class="box-item"
            :class="searchId == item.id?'opt':''"
            @click="onItem(item)"
          >
            {{item.title}}
          </div>
          <div
            v-show="searchList.length == 0"
            style="margin:auto"
          >
            <van-empty
              image="search"
              image-size="60"
              description="暂无搜索结果"
            />
          </div>
        </div>
      </div>

    </div>

    <div
      class=" marg-bottom10"
      style="margin-bottom:70px"
    >
      <div style="font-size:20px;font-weight: 700;padding-bottom: 10px;">场次</div>
      <div style="padding:10px 0">

        <div
          class="boxs"
          style="padding:0;"
        >
          <div
            v-for="(item,index) in sessionList"
            :key="index"
            class="box-item"
            :class="sessionId ==item.id?'opt':''"
            @click="onSession(item)"
          >
            {{item.text}}
          </div>
          <div
            v-show="sessionList.length == 0"
            style="margin:auto"
          >
            <van-empty
              image="search"
              image-size="100"
              description="暂无场次"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="footers">
      <van-button
        type="info"
        size="large"
        @click="onSumbit()"
      >读取</van-button>
    </div>

  </div>
</template>
<script>
import { Dialog } from 'vant'
export default {
  data() {
    return {
      project_id: '',
      serachValue: '',
      searchId: '',
      searchList: [],
      sessionList: [],
      sessionValue: '',
      sessionId: '',
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.goSearch()
  },
  methods: {
    goSearch() {
      this.$axios
        .get('party/search-list', {
          params: {
            keyword: this.serachValue,
          },
        })
        .then((res) => {
          this.searchList = res.data.data
        })
    },
    onItem(item) {
      this.serachValue = item.title
      this.searchId = item.id
      this.$axios
        .get('party/set-list', {
          params: {
            party_id: item.id,
          },
        })
        .then((res) => {
          this.sessionList = res.data.data
        })
    },
    onSession(item) {
      this.sessionValue = item.text
      this.sessionId = item.id
    },
    onSumbit() {
      if (!this.sessionId && !this.sessionValue) {
        this.$toast('请选择有效的场次')
        return
      }

      this.$axios
        .post('partner/apply-batch', {
          project_id: this.project_id,
          set_id: this.sessionId,
        })
        .then((res) => {
          if (res.data.code == 400) {
            this.$toast(res.data.msg)
            return
          }

          Dialog.alert({
            message: res.data.message,
          }).then(() => {
            this.$router.go(-1)
          })
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;

  .marg-bottom10 {
    margin-bottom: 10px;
  }

  .footers {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 700;
    background-color: #fff;
  }

  .boxs {
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    .box-item {
      display: block;
      width: 100%;
      padding: 5px;
      font-size: 14px;
      background: #f1f1f1;
      margin-top: 5px;
    }
  }
  .opt {
    background: coral !important;
  }
}
</style>